import React, { FC } from 'react';

import { EvLoader } from '@evinced-private/ui-common';

import { ICollection } from '../../../../interfaces/Collection';
import { IProperty } from '../../../../interfaces/Property';
import { ShowPropertiesButton } from '../show-properties-button/ShowPropertiesButton';

import { CollectionsPropertiesCellTag } from './CollectionsPropertiesCellTag';

import './CollectionsPropertiesCell.scss';

export const CollectionsPropertiesCell: FC<{
	row: ICollection;
	properties?: IProperty[];
}> = ({ row, properties }) => {
	if (!properties?.length) {
		return <EvLoader message="Loading..." />;
	}

	if (!row || !row.properties || !row.properties.length) {
		return null;
	}

	const propertiesToDisplay = 4;
	const propertiesCount = row.properties.length;
	const extraLabelsCount = propertiesCount - propertiesToDisplay;
	const propertiesToRender = row.properties?.slice(0, propertiesToDisplay).map((id) => {
		const property = properties?.find((prop) => prop.id === id);

		return <CollectionsPropertiesCellTag key={id} property={property} />;
	});

	return (
		<div className="collections-properties-cell">
			{propertiesToRender}
			{extraLabelsCount > 0 && (
				<ShowPropertiesButton
					collection={row}
					properties={properties}
					buttonChildren={<div className="remaining-count-button">+{extraLabelsCount}</div>}
				/>
			)}
		</div>
	);
};
